// extracted by mini-css-extract-plugin
export default {"horizontal":"StudienArztin_horizontal__ErbZs","box":"StudienArztin_box__3xd47"};